// extracted by mini-css-extract-plugin
export default {"result":"Result_result__FOxfB","btn":"Result_btn__g25-l","btn-container":"Result_btn-container__QEoKX"};